import { useEffect } from 'react';
import { FallbackProps } from 'react-error-boundary';

import { appInsightsPlugin } from 'app/modules/AppInsights';
import { ErrorDialog } from 'pkg/components/ErrorHandling/ErrorDialog';

export const RuntimeErrorFallback = ({ error, resetErrorBoundary }: FallbackProps): JSX.Element => {
  useEffect(() => {
    appInsightsPlugin.trackException({ exception: error }, { type: 'Runtime Error' });
  }, [error]);

  return <ErrorDialog onClose={resetErrorBoundary} />;
};
